/**
 * Created by Vladislav on 25.09.2024.
 */

const MethaStarsMenuBarItem = {
    name: "MethaStarsItem",
    targets: ["metaStar"],
    plusButton: true,
    value: function () {
        return cleverapps.meta.getSelectedLocation().stars;
    },
    updater: function (f) {
        cleverapps.meta.on("changeStars", f, this);
    },
    onClickWindow: () => GuideWindow,
    onClickOptions: {
        name: "HomefixRulesWindow",
        bundle: bundles.homefixruleswindow
    },
    icon: bundles.menubar.frames.meta_star_png,
    availableOnScenes: [cleverapps.Environment.SCENE_MAIN]
};